module.exports = "/_next/static/images/hirehac-logo-short-dark-ee370671ff77e347827959186120b2f5.png";